// Shipping Protection v3 - Fixed position bug
(function() {
  'use strict';

  var TIERS = [
    { max: 50,   id: '51923881361540', price: '0.99',  maxDisplay: '$50' },
    { max: 100,  id: '51923881394308', price: '1.99',  maxDisplay: '$100' },
    { max: 200,  id: '51923881427076', price: '2.99',  maxDisplay: '$200' },
    { max: 500,  id: '51923881492612', price: '4.99',  maxDisplay: '$500' },
    { max: Infinity, id: '51923881525380', price: '9.99', maxDisplay: '$500+' }
  ];
  var ALL_IDS = ['51923881361540','51923881394308','51923881427076','51923881492612','51923881525380'];
  var _tier = TIERS[0];
  var _hasItems = false;
  var _updating = false;
  var _initialized = false;

  function getTier(t) { for (var i = 0; i < TIERS.length; i++) if (t <= TIERS[i].max) return TIERS[i]; return TIERS[4]; }
  function ajax(url, opts) {
    return new Promise(function(r,s){
      var x = new XMLHttpRequest();
      x.open(opts.method||'GET',url,true);
      if(opts.contentType) x.setRequestHeader('Content-Type',opts.contentType);
      x.onload=function(){r(x)}; x.onerror=function(){s(x)};
      if(opts.body) x.send(opts.body); else x.send();
    });
  }
  function fetchCart() { return ajax('/cart.js',{method:'GET'}).then(function(x){return x.status===200?JSON.parse(x.responseText):{total_price:0,item_count:0,items:[]};}); }

  function injectStyles() {
    if (document.getElementById('shi-v2-style')) return;
    var s = document.createElement('style');
    s.id = 'shi-v2-style';
    s.textContent = [
      '#shi-app-root{display:none;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;font-size:13px;line-height:1.4;color:#111;margin:0;padding:4px 16px 8px;background:#fff;}',
      '#shi-app-root .row{display:flex;align-items:center;justify-content:space-between;padding:3px 0;}',
      '#shi-app-root .left{display:flex;align-items:center;gap:6px;}',
      '#shi-app-root .icon{display:flex;align-items:center;width:15px;height:15px;}',
      '#shi-app-root .icon svg{width:15px;height:15px;display:block;}',
      '#shi-app-root .label{font-size:13px;font-weight:500;color:#111;}',
      '#shi-app-root .info{background:none;border:none;padding:0;cursor:pointer;display:flex;align-items:center;margin-left:2px;}',
      '#shi-app-root .info svg{width:14px;height:14px;display:block;color:#9ca3af;}',
      '#shi-app-root .info:hover svg{color:#111;}',
      '#shi-app-root .price{font-size:13px;font-weight:600;color:#111;}',
      '#shi-app-root .desc{font-size:11px;color:#6b7280;padding:0 0 2px 0;}',
      '#shi-skip-link{display:none;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;font-size:11px;color:#6b7280;text-align:center;padding:4px 0 6px;cursor:pointer;text-decoration:underline;text-underline-offset:2px;}',
      '#shi-skip-link:hover{color:#111;}',
      '.shi-modal{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.45);z-index:999999;display:flex;align-items:center;justify-content:center;padding:20px;}',
      '.shi-modal > div{background:#fff;border-radius:16px;padding:24px;max-width:380px;width:100%;position:relative;box-shadow:0 20px 60px rgba(0,0,0,0.15);}',
      '.shi-modal .close{position:absolute;top:12px;right:16px;background:none;border:none;font-size:24px;color:#9ca3af;cursor:pointer;padding:0;line-height:1;}',
      '.shi-modal .close:hover{color:#111;}',
      '.shi-modal h3{font-size:18px;font-weight:700;margin:0 0 12px;color:#111;}',
      '.shi-modal .body{font-size:14px;color:#374151;line-height:1.6;}',
      '.shi-modal .body p{margin:0 0 10px;}',
      '.shi-modal .cost{font-weight:600;}',
    ].join('\n');
    document.head.appendChild(s);
  }

  function ensureWidget() {
    if (document.getElementById('shi-app-root')) return;
    var w = document.createElement('div');
    w.id = 'shi-app-root';
    w.innerHTML = '<div class="row"><div class="left"><span class="icon"><svg viewBox="0 0 15 16" width="15" height="16"><path d="M0 0h15v16H0z"/><g fill="#000" fill-rule="nonzero" transform="translate(2 2.5)"><path d="M0 0h11v11H0z" opacity="0"/><path d="M10.329 1.801L5.86.134A.86.86 0 005.5.07a.86.86 0 00-.362.066L.668 1.81A.976.976 0 000 2.776v4.652c0 .38.208.73.544.91l4.486 2.409c.152.082.32.123.488.123.158 0 .316-.037.46-.109l4.452-2.226A.975.975 0 0010.5 7.613V2.768a.975.975 0 00-.671-.967zM5.38.778c.039-.014.08-.021.12-.021s.082.007.12.021l3.928 1.465c.113.042.112.202-.001.242L8.294 2.93a.083.083 0 01-.124-.003L4.216 1.29c-.037-.015-.036-.067.001-.08zM5.156 9.603c0 .195-.208.319-.38.227L.87 7.732A.327.327 0 01.687 7.43V3.31c0-.178.176-.303.345-.243l3.782 1.35c.205.073.343.268.343.486v4.702zm-.003-5.796L1.464 2.49c-.113-.041-.115-.2-.002-.242l1.646-.618c.04-.015.086-.015.125.002l3.929 1.625c.036.015.035.067-.002.08l-1.314.47a.935.935 0 01-.693 0zm5.16 3.805c0 .131-.073.25-.19.307l-3.906 1.953c-.171.086-.373-.039-.373-.231V5.702c0-.218.138-.412.343-.486l1.491-.533c.028-.01.057.01.057.041v2.124c0 .063.068.105.125.077l.468-.234a.155.155 0 00.095-.154V5.54c0-.073.046-.137.114-.162l1.432-.511c.167-.06.344.064.344.243z"/></g></svg></span><span class="label">Shipping Protection</span><button class="info" type="button"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg></button></div><span class="price" id="shi-price">$0.00</span></div><div class="desc">Quick refund for lost, damaged or delayed package.</div>';
    w.querySelector('.info').onclick = function(e){e.preventDefault();showModal();};
    document.body.appendChild(w);
    if (!document.getElementById('shi-skip-link')) {
      var sk = document.createElement('div');
      sk.id = 'shi-skip-link';
      sk.textContent = 'Checkout without shipping protection';
      sk.onclick = function(){window.location.href='/checkout';};
      document.body.appendChild(sk);
    }
  }

  function showModal() {
    if (document.querySelector('.shi-modal')) return;
    var m = document.createElement('div');
    m.className = 'shi-modal';
    m.innerHTML = '<div><button class="close">&times;</button><h3>&#x1F6E1;&#xFE0F; Shipping Protection</h3><div class="body"><p><strong>What is Shipping Protection?</strong></p><p>Shipping Protection covers your order in case it gets lost, damaged, or delayed during transit. If anything happens to your package, you\'ll receive a quick refund &mdash; no hassle.</p><p><strong>Coverage:</strong> Up to ' + _tier.maxDisplay + '</p><p><strong>Cost:</strong> $<span class="cost">' + _tier.price + '</span></p><p><strong>How to claim:</strong> Contact us with your order number and we\'ll process your refund within 24&ndash;48 hours.</p></div></div>';
    m.onclick = function(e) { if (e.target === m || e.target.className === 'close') m.remove(); };
    document.body.appendChild(m);
  }

  // FIXED: Check if drawer is ACTUALLY open, not just in DOM
  function isDrawerOpen() {
    var d = document.querySelector('cart-drawer');
    if (!d) return false;
    return d.classList.contains('is-open') || d.classList.contains('is-active') || d.getAttribute('open') !== null;
  }

  function positionWidget() {
    var w = document.getElementById('shi-app-root');
    var sk = document.getElementById('shi-skip-link');
    if (!w || !sk) return;

    // Only use drawer if it's ACTUALLY open (not hidden on cart page)
    if (isDrawerOpen()) {
      var drawerInner = document.querySelector('#CartDrawer .drawer__inner');
      var btn = document.querySelector('#CartDrawer-Checkout');
      if (drawerInner && btn && btn.parentNode && btn.offsetParent !== null) {
        var p = btn.parentNode;
        if (w.parentNode !== p) p.insertBefore(w, btn);
        if (sk.parentNode !== p) p.insertBefore(sk, btn.nextSibling || null);
        w.style.display = '';
        sk.style.display = 'block';
        return;
      }
    }

    // Cart page
    var cartFooter = document.querySelector('.cart__footer');
    if (cartFooter) {
      var p = cartFooter.parentNode;
      if (w.parentNode !== p) p.appendChild(w);
      if (sk.parentNode !== p) p.appendChild(sk);
      w.style.display = '';
      sk.style.display = 'block';
      return;
    }

    // No suitable location found
    w.style.display = 'none';
    sk.style.display = 'none';
  }

  function updateDisplay() {
    var priceEl = document.getElementById('shi-price');
    if (!priceEl) return;
    priceEl.textContent = '$' + _tier.price;
    var btns = document.querySelectorAll('#CartDrawer-Checkout, #checkout');
    btns.forEach(function(btn) {
      if (!btn.getAttribute('data-shi-base')) btn.setAttribute('data-shi-base', btn.textContent.trim() || 'Check out');
      var base = btn.getAttribute('data-shi-base');
      btn.textContent = _hasItems ? (base + ' + $' + _tier.price) : base;
      if (!btn._shiBound) {
        btn._shiBound = true;
        btn.addEventListener('click', function(e) {
          if (!_hasItems) return;
          e.preventDefault(); e.stopPropagation();
          this.disabled = true; this.innerHTML = 'Adding...';
          ajax('/cart/add.js',{method:'POST',contentType:'application/json',body:JSON.stringify({id:_tier.id,quantity:1})})
            .then(function(x){window.location.href='/checkout';}).catch(function(){window.location.href='/checkout';});
        });
      }
    });
  }

  function hideDynamic() {
    document.querySelectorAll('.cart__dynamic-checkout-buttons, .dynamic-checkout__content')
      .forEach(function(e) { if (e) e.style.display = 'none'; });
  }

  function cleanup() {
    return fetchCart().then(function(cart) {
      for (var i = 0; i < cart.items.length; i++) {
        if (ALL_IDS.indexOf(String(cart.items[i].variant_id)) !== -1) {
          return ajax('/cart/change.js',{method:'POST',contentType:'application/json',body:JSON.stringify({id:cart.items[i].variant_id,quantity:0})});
        }
      }
    }).catch(function(){});
  }

  function tick() {
    if (_updating) return;
    _updating = true;
    fetchCart().then(function(cart) {
      var total = (cart.total_price || 0) / 100;
      _tier = getTier(total);
      _hasItems = cart.item_count > 0;

      if (!_initialized) {
        injectStyles();
        ensureWidget();
        _initialized = true;
      }

      if (_hasItems) {
        positionWidget();
        updateDisplay();
        hideDynamic();
      } else {
        var w = document.getElementById('shi-app-root');
        var sk = document.getElementById('shi-skip-link');
        if (w) w.style.display = 'none';
        if (sk) sk.style.display = 'none';
        document.querySelectorAll('#CartDrawer-Checkout, #checkout').forEach(function(btn) {
          var base = btn.getAttribute('data-shi-base');
          if (base) btn.textContent = base;
        });
      }
    }).catch(function(){}).then(function(){_updating = false;});
  }

  function init() {
    if (window.location.pathname.indexOf('/checkout') === 0) return;
    if (window.location.pathname.indexOf('/orders/') === 0) return;
    cleanup().then(function(){tick();setInterval(tick,800);});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
